export enum ReferFriendWidget {
    MainPage = 1,
    ThankYouPage = 2,
    Influencers = 3,
    InfluencersPro = 4,
    InfluencersVip = 5,
}